"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tooltip = require("@nivo/tooltip");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
const SlicesItem = ({
  slice,
  axis,
  debug,
  tooltip,
  isCurrent,
  setCurrent
}) => {
  const _useTooltip = (0, _tooltip.useTooltip)(),
        showTooltipFromEvent = _useTooltip.showTooltipFromEvent,
        hideTooltip = _useTooltip.hideTooltip;

  const handleMouseEnter = (0, _react.useCallback)(event => {
    showTooltipFromEvent(_react.default.createElement(tooltip, {
      slice,
      axis
    }), event, 'right');
    setCurrent(slice);
  }, [showTooltipFromEvent, tooltip, slice]);
  const handleMouseMove = (0, _react.useCallback)(event => {
    showTooltipFromEvent(_react.default.createElement(tooltip, {
      slice,
      axis
    }), event, 'right');
  }, [showTooltipFromEvent, tooltip, slice]);
  const handleMouseLeave = (0, _react.useCallback)(() => {
    hideTooltip();
    setCurrent(null);
  }, [hideTooltip]);
  return _react.default.createElement("rect", {
    x: slice.x0,
    y: slice.y0,
    width: slice.width,
    height: slice.height,
    stroke: "red",
    strokeWidth: debug ? 1 : 0,
    strokeOpacity: 0.75,
    fill: "red",
    fillOpacity: isCurrent && debug ? 0.35 : 0,
    onMouseEnter: handleMouseEnter,
    onMouseMove: handleMouseMove,
    onMouseLeave: handleMouseLeave
  });
};

SlicesItem.propTypes = process.env.NODE_ENV !== "production" ? {
  slice: _propTypes.default.object.isRequired,
  axis: _propTypes.default.oneOf(['x', 'y']).isRequired,
  debug: _propTypes.default.bool.isRequired,
  height: _propTypes.default.number.isRequired,
  tooltip: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  isCurrent: _propTypes.default.bool.isRequired,
  setCurrent: _propTypes.default.func.isRequired
} : {};

var _default = (0, _react.memo)(SlicesItem);

exports.default = _default;
module.exports = exports.default;